// use client: React context provider consumed by client leaves (LetsConnect)
'use client'

import type { GlobalChrome } from '@/utils/getGlobalChrome'

import { createContext, useContext } from 'react'

/**
 * Build-time chrome data, published once by AppShell.
 *
 * LetsConnect is imported by 54 view files, so threading its contact data down
 * as a prop would be a large, error-prone diff. The value is set once at build
 * time and never updates, so there is no re-render cost to a context here.
 * See docs/superpowers/plans/2026-08-17-remove-client-side-cms-refetch.md Task 8.
 */
const GlobalChromeContext = createContext<GlobalChrome | null>(null)

export const GlobalChromeProvider = GlobalChromeContext.Provider

export const useContactData = () => useContext(GlobalChromeContext)?.contactData ?? []

export const useBranches = () => useContext(GlobalChromeContext)?.branches ?? []

export const useEnquiryFormOptions = () =>
  useContext(GlobalChromeContext)?.enquiryFormOptions ?? null
